import { tableColumnKeys, useFormattedCarbonReductionData } from "./BuildingPage.helper";

class CarbonReductionPlanCsvExporter {
    private readonly plan: CarbonReductionPlan;

    private readonly grossFloorArea: number;

    constructor(plan: CarbonReductionPlan, grossFloorArea: number) {
        this.plan = plan;
        this.grossFloorArea = grossFloorArea;
    }

    toCsvRows(): Record<string, unknown>[] {
        return this.formatMeasuresTwo();
    }

    private formatMeasuresTwo(): Record<string, unknown>[] {
        const { dataSource } = useFormattedCarbonReductionData(
            this.plan.carbonReductionMeasures,
            this.grossFloorArea,
            this.plan.carbonReductionPlanUid
        );
        const exportData = [...dataSource]
            .sort((a, b) => (a.yearApplied ?? 0) - (b.yearApplied ?? 0))
            .map((row) => Object.fromEntries(tableColumnKeys.map((key) => [key, row[key]])));
        return exportData;
    }
}

export default CarbonReductionPlanCsvExporter;
